/**
 * The Different Activity Types, Most of it are supported by google directions API
 */
export var ActivityType;
(function (ActivityType) {
    ActivityType["STATIONARY"] = "STATIONARY";
    ActivityType["WALKING"] = "WALKING";
    ActivityType["RUNNING"] = "RUNNING";
    ActivityType["CYCLING"] = "CYCLING";
    ActivityType["CAR"] = "CAR";
    ActivityType["EV"] = "EV";
    ActivityType["AIRPLANE"] = "AIRPLANE";
    ActivityType["TRAIN"] = "TRAIN";
    ActivityType["BUS"] = "BUS";
    ActivityType["FERRY"] = "FERRY";
    ActivityType["METRO"] = "METRO";
    ActivityType["TRAM"] = "TRAM";
    ActivityType["SUBWAY"] = "SUBWAY";
    ActivityType["CABLE_CAR"] = "CABLE_CAR";
    ActivityType["COMMUTER_TRAIN"] = "COMMUTER_TRAIN";
    ActivityType["FUNICULAR"] = "FUNICULAR";
    ActivityType["GONDOLA_LIFT"] = "GONDOLA_LIFT";
    ActivityType["HEAVY_RAIL"] = "HEAVY_RAIL";
    ActivityType["HIGH_SPEED_TRAIN"] = "HIGH_SPEED_TRAIN";
    ActivityType["INTERCITY_BUS"] = "INTERCITY_BUS";
    ActivityType["LONG_DISTANCE_TRAIN"] = "LONG_DISTANCE_TRAIN";
    ActivityType["METRO_RAIL"] = "METRO_RAIL";
    ActivityType["MONORAIL"] = "MONORAIL";
    ActivityType["OTHER"] = "OTHER";
    ActivityType["RAIL"] = "RAIL";
    ActivityType["SHARE_TAXI"] = "SHARE_TAXI";
    ActivityType["TROLLEYBUS"] = "TROLLEYBUS";
})(ActivityType || (ActivityType = {}));
